var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_744_6523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3454 50.6079H41.2126V74.7622C41.2126 75.2391 41.599 75.6255 42.0759 75.6255H52.024C52.5009 75.6255 52.8873 75.2391 52.8873 74.7622V50.7216H59.6322C60.0707 50.7216 60.4397 50.3925 60.4898 49.9569L61.5142 41.0645C61.5423 40.8198 61.4648 40.5748 61.3011 40.3913C61.1373 40.2076 60.9028 40.1024 60.6568 40.1024H52.8877V34.5282C52.8877 32.8479 53.7924 31.9958 55.5771 31.9958C55.8314 31.9958 60.6568 31.9958 60.6568 31.9958C61.1337 31.9958 61.5201 31.6092 61.5201 31.1325V22.97C61.5201 22.4931 61.1337 22.1067 60.6568 22.1067H53.6562C53.6068 22.1043 53.4972 22.1003 53.3356 22.1003C52.1209 22.1003 47.8988 22.3388 44.5636 25.407C40.8683 28.807 41.382 32.8781 41.5048 33.5839V40.1022H35.3454C34.8685 40.1022 34.4821 40.4887 34.4821 40.9656V49.7444C34.4821 50.2213 34.8685 50.6079 35.3454 50.6079Z",
    fill: "#EC1C2E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 46.2448,
    stroke: "#EC1C2E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_744_6523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.5252,
    height: 53.5252,
    fill: "white",
    transform: "translate(21.2372 22.1016)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.5f6531e1aac77af0b39105781dab254e.svg";
export { ForwardRef as ReactComponent };